module.exports = __webpack_public_path__ + "img/06.3778b8d9.jpg";